export default [
  {
    title: 'Cook’s profile is inappropriate',
    icon: '$vuetify.icons.tag',
    reason: 'CHEF_PROFILE'
  },
  {
    title: 'There was another issue',
    icon: '$vuetify.icons.frown',
    reason: 'OTHER'
  }
]
